import { REQUEST_REPLY_DRAFT_AGENT_NOT_PLATFORM } from '@featit/shared/request-reply-draft';
import { failures } from '@featit/shared/i18n/messages/en/failures';
import { registerEnglishArea } from '@/i18n/catalogue';
import { englishT } from '@/i18n/LocaleProvider';
import { pageT } from '@/i18n/pageTranslator';

registerEnglishArea('failures', failures);

/**
 * F-0786 PAG-7a: the sentence a refused drafting agent says, in the page's language.
 *
 * The server refuses a `policies` write naming, as the agent that drafts the reply to a request, one
 * FEATit does not run, with a 400 that carries `code: 'request_reply_draft_agent_not_platform'` and an
 * English sentence for the CLI. The reader is told from the code, out of the catalogue
 * (`failures.replyDraftAgentNotPlatform`). Null for any other failure. Read where a refusal's sentence
 * is read, `actionFailure.ts` and `ApiService.httpErrorMessage`, as the verification refusal is.
 */
export function replyDraftAgentRefusalSentence(error: unknown): string | null {
  const candidate = error as {
    response?: { data?: unknown };
    extensions?: { originalError?: unknown } & Record<string, unknown>;
  } | null;
  for (const body of [
    candidate?.response?.data,
    candidate?.extensions?.originalError,
    candidate?.extensions,
  ]) {
    if (
      (body as { code?: unknown } | null | undefined)?.code ===
      REQUEST_REPLY_DRAFT_AGENT_NOT_PLATFORM
    ) {
      return pageT(englishT)('failures.replyDraftAgentNotPlatform');
    }
  }
  return null;
}
